import React, { useEffect } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Legal.css';
import '../components/Pages/About/About.css';

const UserAgreement = () => {
  // 确保页面加载时滚动到顶部
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, []);
  
  return (
    <div className="elegant-app">
      <Header />
      
      <main className="elegant-about-container">
        <div className="elegant-about-header">
          <h1 className="elegant-about-title">用户协议</h1>
          <p className="elegant-about-subtitle">更新日期：2025-04-14 | 生效日期：2025-08-01</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>1. 总则</h2>
          <p>欢迎使用 HugTub 海龟汤平台（以下简称"本平台"）。本协议是您与本平台之间关于使用本平台服务所订立的协议。请您仔细阅读本用户协议，您注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。</p>
          <p>如果您未满 18 周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>2. 账户注册与安全</h2>
          <p>2.1 用户在使用本平台服务前需要注册账户。您承诺提供真实、准确、完整的注册信息，并及时更新相关资料。</p>
          <p>2.2 您应自行保管账户密码，如因您保管不善导致的任何损失，本平台不承担责任。</p>
          <p>2.3 您同意不将账号、密码转让或授权给他人使用。如发现有他人未经您的授权使用您的账号，应立即通知本平台。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>3. 内容规范</h2>
          <p>3.1 用户在本平台创作、发布的所有内容（包括但不限于文字、图片、视频等）应符合国家法律法规，不得含有以下内容：</p>
          <ul className="elegant-list">
            <li>反对宪法确定的基本原则的内容</li>
            <li>危害国家安全、泄露国家秘密的内容</li>
            <li>宣扬恐怖主义、极端主义的内容</li>
            <li>宣扬民族仇恨、民族歧视的内容</li>
            <li>扰乱社会秩序、破坏社会稳定的内容</li>
            <li>侮辱、诽谤他人，侵害他人合法权益的内容</li>
            <li>含有色情、暴力、恐怖或者教唆犯罪的内容</li>
            <li>法律法规禁止的其他内容</li>
          </ul>
          <p>3.2 用户不得利用本平台进行任何违法或不当的活动，包括但不限于发布违禁信息、骚扰他人、散布垃圾信息等。</p>
          <p>3.3 用户在平台上创作的海龟汤内容应当遵循平台规范，海龟汤的解谜过程应当公平、合理，不应设置不可能被解开的谜题。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>4. 知识产权</h2>
          <p>4.1 本平台所有权、经营权、运作权和知识产权均归本平台所有。</p>
          <p>4.2 用户在本平台上发布的内容，用户保留著作权和其他相关权利。发布行为即表明用户授予本平台及其关联公司非独占性、可转授权、不可撤销、全球性、免费的许可，允许本平台使用、复制、修改、改编、出版、翻译、创建衍生作品，及在全球范围内以任何形式分发、展示此等内容。</p>
          <p>4.3 用户保证其上传、发布的内容不侵犯任何第三方的知识产权或其他权利。如因用户内容引起的知识产权纠纷，由用户自行承担全部责任。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>5. 隐私保护</h2>
          <p>本平台重视用户隐私保护，具体规则请参见《隐私政策》。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>6. 免责声明</h2>
          <p>6.1 本平台不对用户发布的内容进行事先审查，但保留在发现违规内容后进行处理的权利。</p>
          <p>6.2 因网络状况、通讯线路、第三方平台或其他不可抗力导致的服务中断或不能满足用户要求的，本平台不承担任何责任。</p>
          <p>6.3 用户间通过本平台产生的纠纷，由纠纷双方自行解决，本平台不承担任何责任。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>7. 协议修改</h2>
          <p>本平台有权在必要时修改本协议条款。您可以在相关页面中查阅最新版本的协议条款。本协议条款变更后，如果您继续使用本平台提供的服务，即视为您已接受修改后的协议。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>8. 终止服务</h2>
          <p>8.1 您有权通过注销账号的方式终止使用本平台服务。</p>
          <p>8.2 如您违反本协议相关规定，本平台有权限制、冻结或终止您的账号，并有权追究您的相关责任。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>9. 法律适用与争议解决</h2>
          <p>9.1 本协议的成立、生效、履行和解释，适用中华人民共和国大陆地区法律。</p>
          <p>9.2 因本协议引起的或与本协议有关的任何争议，各方应友好协商解决；协商不成的，任何一方均可将有关争议提交至本平台所在地有管辖权的人民法院诉讼解决。</p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default UserAgreement; 